import Slider from '@react-native-community/slider';
import React from 'react';
import './slider.css';

const WebSlider = props => {
   return (
      <Slider
         value={props?.value}
         minimumValue={props?.minimumValue}
         onSlidingComplete={value => props?.onSlidingComplete(value)}
         disabled={props?.disabled}
         maximumValue={props?.maximumValue}
         thumbTouchSize={props?.thumbTouchSize}
         thumbStyle={props?.thumbStyle}
         minimumTrackTintColor={props?.minimumTrackTintColor}
         maximumTrackTintColor={props?.maximumTrackTintColor}
         trackStyle={props?.trackStyle}
         style={props?.style}
         thumbTintColor={props?.thumbTintColor}
      />
   );
};

export default WebSlider;
